import { css } from 'styled-components';
import { withUnit } from '../core/withUnit.js';

const margin = css `
  margin: ${props => withUnit(props.$margin)};
  margin-top: ${props => withUnit(props.$marginTop)};
  margin-right: ${props => withUnit(props.$marginRight)};
  margin-bottom: ${props => withUnit(props.$marginBottom)};
  margin-left: ${props => withUnit(props.$marginLeft)};
`;

export { margin };
//# sourceMappingURL=margin.js.map
